/**
 * The Copy link button under a share-friendly, which copies the GIF's own
 * address. `share-friendly.ts` starts it beside the Share button and says why
 * an address is what goes on the clipboard.
 */

import { type ShareFriendlyBrowser, shown } from "./share-friendly.js";

/** How long the copy button says what happened before going back. */
const feedbackMilliseconds = 2000;

/** Show the copy button where there is a clipboard to copy to. */
export function offerLink(
  section: Element,
  browser: ShareFriendlyBrowser,
): void {
  const button = section.querySelector<HTMLButtonElement>(
    "button[data-share-link]",
  );
  const said = button?.querySelector(".share-friendly-link-said");
  const address = button?.dataset["shareLink"];
  const { clipboard } = browser.navigator;

  if (
    button === null ||
    button === undefined ||
    said === null ||
    said === undefined ||
    address === undefined ||
    typeof clipboard?.writeText !== "function"
  ) {
    return;
  }

  const label = said.textContent;
  let restore: ReturnType<typeof setTimeout> | undefined;

  button.addEventListener("click", () => {
    const whole = new URL(address, button.ownerDocument.baseURI).href;

    clipboard.writeText(whole).then(
      () => {
        settle("Copied");
      },
      () => {
        settle("Could not copy");
      },
    );
  });
  shown(button);

  /** Say what happened, and go back to the label two seconds later. */
  function settle(outcome: string): void {
    said!.textContent = outcome;

    if (restore !== undefined) {
      clearTimeout(restore);
    }

    restore = setTimeout(() => {
      said!.textContent = label;
      restore = undefined;
    }, feedbackMilliseconds);
  }
}
